<template>
  <div>
    <h3 class="stitle mb50">체험자 정보</h3>
    <template v-if="experPcntList.length > 0">
      <div v-if="chkChildAge" class="age-caution">
        <p class="caution-title">체험 관련 주의사항</p>
        <p class="caution-msg">
          1. 할인 및 면제 대상자 지참서류 안내 <a href="https://www.koreajobworld.or.kr/boardView.do?bid=1&mid=42&idx=34881&rnum=1&site=10&portalMenuNo=39&searchField=0" target="_blank" class="link-style">[클릭]</a>
        </p>
        <p class="caution-msg">
          2. <b>어린이체험관</b>은 <b>만 48개월 이상 초등학교 4학년 이하인 어린이</b>가 이용 가능합니다.
        </p>
        <p class="caution-msg">
          <b>현장 발권 및 체험관 입장이 제한</b>될 수 있으니 체험일과 생년월일을 확인해주시기 바랍니다.
        </p>
        <p class="caution-msg">
          3. 이용기준: 일부 체험실은 체험자가 글을 읽거나 컴퓨터를 사용할 수 있어야 원활한 체험이 가능하며, 체험자의 연령·신장 등에 따라 이용이 제한될 수 있습니다.
        </p>
        <p class="caution-msg">
          4. 어린이체험관 이용에 따른 개인정보 처리방침: 한국잡월드는 다음의 목적을 위하여 개인정보를 처리합니다. 처리하고 있는 개인정보는 다음의 목적 외의 용도로는 이용되지 않으며, 이용 목적이 변경되는 경우에는 「개인정보 보호법」 제18조에 따라 별도의 동의를 받는 등 필요한 조치를 이행합니다.
        </p>
        <p class="caution-msg">
          1) 체험 대기열 관리를 위한 체험자의 성명
        </p>
        <p class="caution-msg">
          2) 체험 서비스 계약 이행을 위한 사진, 영상
        </p>
        <p class="caution-msg" style="font-size: 15px;">
          ※ 체험 사진은 별도로 저장되지 않으며, 영상은 체험일로부터 5일이 경과하면 영구 삭제합니다.
        </p>
        <label style="cursor: pointer">
          <span style="line-height: 32px">
            <input type="checkbox" id="chkChildAge" name="chkChildAge" style="appearance: auto; width: 16px; height: 16px" v-model="childAgeAgree" />
            확인하였습니다.
          </span>
        </label>
      </div>
      <div v-if="chkYouthAge" class="age-caution">
        <p class="caution-title">체험 관련 주의사항</p>
        <p class="caution-msg">
          1. 할인 및 면제 대상자 지참서류 안내 <a href="https://www.koreajobworld.or.kr/boardView.do?bid=1&mid=42&idx=34881&rnum=1&site=10&portalMenuNo=39&searchField=0" target="_blank" class="link-style">[클릭]</a>
        </p>
        <p class="caution-msg">
          2.<b>청소년체험관</b>은 <b>초등학교 5학년 이상 고등학교 3학년 이하인 청소년</b>만 이용 가능합니다.
        </p>
        <p class="caution-msg">
          <b>현장 발권 및 체험관 입장이 제한</b>될 수 있으니 체험일과 생년월일을 확인해주시기 바랍니다.
        </p>
        <label style="cursor: pointer">
          <span style="line-height: 32px">
            <input type="checkbox" id="chkYouthAge" name="chkChildAge" style="appearance: auto; width: 16px; height: 16px" v-model="childAgeAgree" />
            확인하였습니다.
          </span>
        </label>
      </div>
      <div v-if="chkSkillAge" class="age-caution">
        <p class="caution-title">체험 관련 주의사항</p>
        <p class="caution-msg">
          1. 할인 및 면제 대상자 지참서류 안내 <a href="https://www.koreajobworld.or.kr/boardView.do?bid=1&mid=42&idx=34881&rnum=1&site=10&portalMenuNo=39&searchField=0" target="_blank" class="link-style">[클릭]</a>
        </p>
        <p class="caution-msg">
          2. <b>숙련기술체험관</b>은 <b>초등학교 5학년 이상 고등학교 3학년 이하인 청소년</b>만 이용 가능합니다.
        </p>
        <p class="caution-msg">
          <b>현장 발권 및 체험관 입장이 제한</b>될 수 있으니 체험일과 생년월일을 확인해주시기 바랍니다.
        </p>
        <label style="cursor: pointer">
          <span style="line-height: 32px">
            <input type="checkbox" id="chkSkillAge" name="chkSkillAge" style="appearance: auto; width: 16px; height: 16px" v-model="childAgeAgree" />
            확인하였습니다.
          </span>
        </label>
      </div>
      <transition-group name="list">
        <dl class="mb30" v-for="(info, index) in experPcntList" :key="info.uniqueId">
          <dt class="stitle2 tleft">
            체험자 {{ index + 1 }} 정보
            <span v-if="productItem.pcntYn !== 'Y'">
              <button class="remove-icon" @click="onRemoveExperClick(info)" alt="삭제"></button>
            </span>
            <div class="tit_btnbox customer">
              <a v-if="index === 0" class="" @click="() => onInputMyInfo('exper', info)">내정보 불러오기</a>
              <a class="btn_color" @click="() => openFamilyInfo(2, info)">가족정보 불러오기</a>
            </div>
          </dt>
          <dd class="colorBox">
            <ul class="inputBox">
              <li v-if="info.showExph">
                <label>체험실</label>
                <ul class="tlist1" v-if="info.expProduct && info.expProduct.length > 0">
                  <li v-for="exhp in info.expProduct" :key="exhp.pdNo + '_' + exhp.scheSeqNo">{{ exhp.exhpNm }}</li>
                </ul>
                <span v-else>{{ info.exhpNm }}</span>
              </li>
              <li>
                <label :for="info.key + '_name'">
                  이름
                  <sup class="red">*</sup>
                </label>
                <span>
                  <input type="text" :id="info.key + '_name'" name="incluNm" :value="info.incluNm" @input="onPcntChange($event, info)" maxlength="20" />
                </span>
              </li>
              <li :class="{ hide: !isYouthOrSkill }">
                <label :for="info.key + '_userId'">회원ID</label>
                <span>
                  <input
                    type="text"
                    :id="info.key + '_userId'"
                    name="incluUserId"
                    :value="info.incluUserId"
                    @input="onPcntChange($event, info)"
                    maxlength="20"
                  />
                </span>
              </li>
              <li v-if="chkChildAge">
                <label :for="info.key + '_grade'">
                  학년
                  <sup class="red">*</sup>
                </label>
                <span>
                  <select :id="info.key + '_grade'" name="incluGrade" :value="info.incluGrade" @input="onPcntChange($event, info)">
                    <option v-for="grade in info.gradeList" :key="grade.cd" :value="grade.cd">{{ grade.cdNm }} {{ gradeLabel(grade.cd) }}</option>
                  </select>
                </span>
              </li>
              <li v-else>
                <label :for="info.key + '_grade'">
                  학년
                  <sup class="red">*</sup>
                </label>
                <span>
                  <select :id="info.key + '_grade'" name="incluGrade" :value="info.incluGrade" @input="onPcntChange($event, info)">
                    <option v-for="grade in info.gradeList" :key="grade.cd" :value="grade.cd">
                      {{ grade.cdNm }}
                    </option>
                  </select>
                </span>
              </li>
              <li>
                <label :for="info.key + '_birth'">
                  생년월일
                  <sup class="red">*</sup>
                </label>
                <span class="calselbox">
                  <date-pick
                    v-bind="dateOpt"
                    :format="'YYYY-MM-DD'"
                    :displayFormat="'YYYY-MM-DD'"
                    :inputAttributes="{ readonly: true }"
                    :selectableYearRange="selectableYearRange"
                    :isDateDisabled="isDisabledDate"
                    :startWeekOnSunday="true"
                    :value="info.incluBirthMonDate"
                    @input="onPcntDateChange($event, info)"
                  ></date-pick>
                  <!-- <input type="text" :id="info.key + '_birth'" name="incluBirthMonDate" :value="info.incluBirthMonDate" @input="onPcntChange($event, info)" />
                <button class="calsel" type="button">생년월일</button> -->
                </span>
              </li>
              <li v-if="isYouthOrSkill">
                <label :for="info.key + '_email'">
                  이메일
                  <sup class="red">*</sup>
                </label>
                <span>
                  <input type="text" :id="info.key + '_email'" name="email" :value="info.email" @input="onPcntChange($event, info)" />
                </span>
              </li>
              <li v-if="info.pesnPriceList">
                <label :for="info.key + '_pesnDivCd'">할인대상</label>
                <span>
                  <select name="pesnDivCd" :id="info.key + '_pesnDivCd'" :value="info.pesnDivCd" @input="onPcntPesnDivChange($event, info)">
                    <option v-for="pp in info.pesnPriceList" :key="pp.pesnDivCd" :value="pp.pesnDivCd">{{ pp.note }} ({{ pp.discRate }}%)</option>
                  </select>
                </span>
              </li>
            </ul>
          </dd>
        </dl>
      </transition-group>
    </template>
    <template v-else>
      <h3>체험인원을 선택해 주세요</h3>
    </template>
    <dl v-for="(info, index) in leaderPcntList" :key="info.key">
      <dt class="stitle2 tleft">
        보호자 {{ index + 1 }} 정보
        <span v-if="productItem.pcntYn !== 'Y'">
          <button class="remove-icon" @click="onRemoveExperClick(info)" alt="삭제"></button>
        </span>
        <div class="tit_btnbox customer">
          <a v-if="index === 0" class="" @click="() => onInputMyInfo('leader', info)">내정보 불러오기</a>
          <a class="btn_color" @click="() => openFamilyInfo(1, info)">가족정보 불러오기</a>
        </div>
      </dt>
      <dd class="colorBox">
        <ul class="inputBox">
          <li>
            <label :for="info.key + '_name'">
              이름
              <sup class="red">*</sup>
            </label>
            <span>
              <input type="text" :id="info.key + '_name'" name="leaderNm" :value="info.leaderNm" @input="onPcntChange($event, info)" maxlength="20" />
            </span>
          </li>
          <li>
            <label :for="info.key + '_tel'">
              휴대폰
              <sup class="red">*</sup>
            </label>
            <span>
              <input type="tel" :id="info.key + '_tel'" name="phoneNo" :value="info.phoneNo" @input="onPcntChange($event, info)" maxlength="13" />
            </span>
          </li>
          <li>
            <label :for="info.key + '_email'">
              이메일
              <sup class="red">*</sup>
            </label>
            <span>
              <input type="text" :id="info.key + '_email'" name="email" :value="info.email" @input="onPcntChange($event, info)" maxlength="200" />
            </span>
          </li>
          <li v-if="info.pesnPriceList">
            <label :for="info.key + '_pesnDivCd'">할인대상</label>
            <span>
              <select name="pesnDivCd" :id="info.key + '_pesnDivCd'" :value="info.pesnDivCd" @input="onPcntPesnDivChange($event, info)">
                <option v-for="pp in info.pesnPriceList" :key="pp.pesnDivCd" :value="pp.pesnDivCd">{{ pp.note }} ({{ pp.discRate }}%)</option>
              </select>
            </span>
          </li>
        </ul>
      </dd>
    </dl>
    <div style="padding-top: 15px" data-target="#privateAgree">
      <private-agree-popup v-model="privateAgree" />
    </div>
    <!-- 레이어팝업 -->
    <modal @close="closeModal" :open="modal.open" :title="modal.title">
      <!-- default 슬롯 콘텐츠 -->
      <family-list :value="modal.familyList" :select="selectFamilyInfo" />
      <!-- /default -->
      <!-- footer 슬롯 콘텐츠 -->
      <template slot="footer">
        <!-- <button @click="selectPcnt">확인</button>
        <button @click="closeModal">취소</button> -->
      </template>
      <!-- /footer -->
    </modal>
  </div>
</template>

<script>
import { DATE_LOCALIZATION } from '@/utils/const.js';
import moment from 'moment';
import DatePick from 'vue-date-pick';
import { mapActions, mapGetters, mapState } from 'vuex';
import { getFamilyList } from '@/api/api_reserve';
import FamilyList from '@/components/product/detail/FamilyList.vue';
import Modal from '@/components/common/Modal.vue';
import PrivateAgreePopup from '@/components/popup/PrivateAgreePopup.vue';

export default {
  name: 'CustomerInfo',
  components: { DatePick, Modal, FamilyList, PrivateAgreePopup },
  props: {},
  data() {
    return {
      dateOpt: DATE_LOCALIZATION,
      modal: {
        open: false,
        title: '가족 정보 선택',
        familyList: [],
        target: '',
      },
    };
  },
  computed: {
    ...mapState({
      date: (state) => state.reserve.ticket.date,
      productItem: (state) => state.reserve.productItem,
      experPcntList: (state) => state.reserve.experPcntList,
      leaderPcntList: (state) => state.reserve.leaderPcntList,
      gradeList: (state) => state.reserve.gradeList,
      userInfo: (state) => state.ui,
    }),
    ...mapGetters('reserve', ['mstrPdList', 'chkChildAge', 'chkYouthAge', 'chkSkillAge', 'isYouthOrSkill']),
    childAgeAgree: {
      get() {
        return this.$store.state.reserve.childAgeAgree;
      },
      set(value) {
        this.editReserveInfo({ childAgeAgree: value });
      },
    },
    privateAgree: {
      get() {
        return this.$store.state.reserve.privateAgree;
      },
      set(value) {
        this.editReserveInfo({ privateAgree: value });
      },
    },
    maxBirthDay() {
      return moment(this.date, 'YYYY-MM-DD').subtract(48, 'M').toDate();
    },
    selectableYearRange() {
      // 체험관별 달력 범위 변경
      const pdDiv = this.productItem.pdDiv;
      const toDate = moment(this.date, 'YYYY-MM-DD');
      const maxYear = toDate.clone().subtract(70, 'Y').year(); // 최대 70
      let startYear = toDate.clone().subtract(19, 'Y').year(); // 고3(19)
      let endYear = toDate.clone().subtract(4, 'Y').year(); // 만4살

      if (pdDiv === '01') {
        // 어체
        startYear = toDate.clone().subtract(12, 'Y').year();
        endYear = toDate.clone().subtract(4, 'Y').year();
        //console.log('01 : ' + startYear + ' ' + endYear);
      } else if (pdDiv === '02' || pdDiv === '10') {
        // 청체, 숙련
        startYear = toDate.clone().subtract(19, 'Y').year();
        endYear = toDate.clone().subtract(10, 'Y').year();
        //console.log('02 10 : ' + startYear + ' ' + endYear);
      } else {
        startYear = maxYear;
        endYear = toDate.clone().subtract(4, 'Y').year();
        //console.log('etc : ' + startYear + ' ' + endYear);
      }

      //10 성인
      const fromYear = (this.productItem?.target || '').includes('10') ? maxYear : startYear;
      //const toYear = this.maxBirthDay?.getFullYear() || new Date().getFullYear - 4;
      return { from: fromYear, to: endYear };
    },
  },
  methods: {
    ...mapActions('reserve', ['editReserveInfo', 'changePcntInfo', 'changePcntInfos', 'calcPrice', 'removePcnt']),
    isDisabledDate(date) {
      return date > this.maxBirthDay;
    },
    onPcntDateChange(event, target) {
      this.changePcntInfo({ event: { target: { name: 'incluBirthMonDate', value: event } }, target });
    },
    onPcntPesnDivChange(event, target) {
      // 1인 선택 인원 타입
      const onlyOneList = ['22']; // 800만 할인 (ex. 09 제휴처, 16 워라밸, 22 800만)
      const chkValue = event.srcElement.value;

      // 선택된 보호자 인원 타입별 카운트
      const countMap = {};
      this.leaderPcntList.forEach((e) => {
        const cd = e.pesnDivCd;
        if (countMap[cd]) {
          countMap[cd]++;
        } else {
          countMap[cd] = 1;
        }
      });

      // 1인 선택 타입 초과 확인
      const result = onlyOneList.some((item) => countMap[item] && countMap[item] >= 1 && chkValue == item);
      if (result) {
        // 할인대상명
        const pesnDivNm = target.pesnPriceList.find((item) => item.pesnDivCd === chkValue)?.pesnDivNm;
        // select 이전 값으로 변경
        event.srcElement.value = this.leaderPcntList.find((item) => item.key === target.key)?.pesnDivCd;
        // 1인 선택 안내 문구
        if (chkValue === '22') {
          alert('800만돌파기념 보호자 1인 무료는 예약건당 1인만 선택가능합니다.');
        } else {
          alert(pesnDivNm + '은/는 1인만 선택 가능합니다.');
        }
      } else {
        // 선택 인원 구분값 저장
        this.changePcntInfo({ event, target });
        // 금액 계산
        this.calcPrice(this.groupPerDivCd); //02
      }
    },
    onPcntChange(event, target) {
      this.changePcntInfo({ event, target });
      // target.pcnt = event.target.value
      // this.changePcntCount(target);
    },
    //어체 학년 구분
    gradeLabel(gradeCd) {
      if (['01', 'E1', 'E2', 'E3', 'E4'].includes(gradeCd)) {
        return '';
      } else if (['E5', 'E6'].includes(gradeCd)) {
        return '(가능)';
      }
      return '';
    },

    onInputMyInfo(type, target) {
      let datas = {};
      if (type === 'exper') {
        datas = {
          incluNm: this.userInfo.userName,
          incluUserId: this.userInfo.userId,
          email: this.userInfo.userEmail,
          incluBirthMonDate:
            (this.userInfo.userBirthDay || '').length === 8 ? moment(this.userInfo.userBirthDay, 'YYYYMMDD').format('YYYY-MM-DD') : target.userBirthDay,
        };
      } else if (type === 'leader') {
        datas = {
          leaderNm: this.userInfo.userName,
          phoneNo: this.userInfo.userMobileNum,
          email: this.userInfo.userEmail,
        };
      }

      this.changePcntInfos({ target, datas });
      //console.log(datas);
    },
    openModal() {
      this.modal.open = true;
    },
    closeModal() {
      this.modal.open = false;
    },
    onRemoveExperClick(exper) {
      this.removePcnt(exper);
    },
    selectFamilyInfo(info) {
      this.closeModal();
      const target = this.modal.target;
      if (target) {
        let incluBirthMonDate =
          (info.incluBirthMonDate || '').length === 8 ? moment(info.incluBirthMonDate, 'YYYYMMDD').format('YYYY-MM-DD') : target.incluBirthMonDate;
        let datas = {};
        if (target.reciDivCd === '20') {
          datas = {
            incluNm: info.incluNm || target.incluNm,
            incluBirthMonDate: incluBirthMonDate,
            incluGrade: info.incluGrade || target.incluGrade,
            incluClass: info.incluClass || target.incluClass,
            incluClsNo: info.incluClsNo || target.incluClsNo,
            incluUserId: info.incluUserId || target.incluUserId,
            email: info.email || target.email,
          };
        } else if (target.reciDivCd === '10') {
          datas = {
            leaderNm: info.incluNm || target.leaderNm,
            phoneNo: info.phoneNo || target.phoneNo,
            email: info.email || target.email,
          };
        }

        this.changePcntInfos({ target, datas });
      }
    },
    async openFamilyInfo(linkCd, target) {
      this.openModal();
      this.getUserFamilyList(linkCd);
      this.modal.target = target;
    },
    async getUserFamilyList(linkCd) {
      const data = await getFamilyList(linkCd);
      if (data.success) {
        this.modal.familyList = data.response.familyList;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.hide {
  display: none !important;
}
a {
  cursor: pointer;
}
.age-caution {
  font-size: 16px;

  & p.caution-title {
    color: #e12f36;
    font-weight: 700;
  }
  & * {
    border: none !important;
  }
}

.remove-icon {
  background: url('@/assets/images/icon_close.png') no-repeat;
  width: 16px;
  height: 16px;
}

.vdpComponent {
  width: 100%;
  &::v-deep > input {
    width: 100%;
  }
}

.list-enter-active,
.list-leave-active {
  transition: all 0.2s ease;
}
.list-enter {
  opacity: 0;
  transform: translateX(-30px);
}
.list-leave-to {
  opacity: 0;
  transform: translateX(30px);
}

@media (max-width: 540px) {
  .tit_btnbox.customer {
    position: absolute;
  }
}

.link-style {
  color: #006dbb;
  //text-decoration: underline;
  cursor: pointer;
  font-weight: 500;
}

</style>
